import React from 'react'
import { useSelector } from 'react-redux';


function Insurance() {
    const applicationData = useSelector((state)=> state.appViewDetailsSlice);

  return (
    applicationData.program == 'CPR' && applicationData?.viewAppInfo?.fundGroup != "Travel" ? applicationData.insurance.insuranceAvailable ? 
        <div>    
       
        <div class="intro-y box mt-lg-5">
        <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
            <h2 class="fw-medium fs-base me-auto">
            Policy Details 
            </h2>
        </div>
        <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
             <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                 <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Primary Insurance : <div class="text-gray-600 px-2">{applicationData.insurance.primaryInsuranceCarrier == '--' ? applicationData.insurance.primaryInsuranceOtherCarrier : applicationData.insurance.primaryInsuranceCarrier} </div></div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Insurance Type : <div class="text-gray-600 px-2">{applicationData.insurance.applicantInsuranceType}</div></div>
                </div>
            </div>
                <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Plan Type : <div class="text-gray-600 px-2"> {applicationData.insurance.planType}</div> </div>
                    {/* <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Telephone Number : <div class="text-gray-600 px-2">{applicationData.insurance.phoneNumber}</div></div> */}
    
                </div>
            </div>
            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                <div class="d-flex flex-column  mt-3">
                    {/* <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Policy ID : <div class="text-gray-600 px-2">{applicationData.insurance.policyNumber} </div></div> */}
                   
               </div>
           </div>
        </div>
    </div>
    {/* <div class="intro-y box mt-5">
        <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
            <h2 class="fw-medium fs-base me-auto">
                Subscriber Details 
            </h2>
        </div>
        <div class="d-flex flex-column flex-lg-row p-5  mx-n5 row">
            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                <div class="d-flex flex-column  mt-3">
                   <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Subscriber Name : <div class="text-gray-600 px-2">{applicationData.insurance.subscriberName}  </div></div>
               </div>
           </div>
               <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
               <div class="d-flex flex-column  mt-3">
                   <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Group Number : <div class="text-gray-600 px-2"> {applicationData.insurance.groupNumber} </div> </div>
    
               </div>
           </div>
           <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
               <div class="d-flex flex-column  mt-3">
                   <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Subscriber DOB : <div class="text-gray-600 px-2">{applicationData.insurance.subscriberDOB}  </div></div>
                  
              </div>
          </div>
       </div>
    </div> */}
    <div class="intro-y box mt-5">
        <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
            <h2 class="fw-medium fs-base me-auto">
               {applicationData.program == 'CPR' ? "Insurance Details" : "Insurance Information"}
            </h2>
        </div>
        {/* <div class="d-flex flex-column flex-lg-row p-5  mx-n5 row">
            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                <div class="d-flex flex-column  mt-3">
                   <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Does the patient have a medicare supplement : <div class="text-gray-600 px-2">{applicationData.insurance.hasMedicareSupplement} </div></div>
               </div>
           </div>
               <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
               <div class="d-flex flex-column  mt-3">
                   <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Do you have medicare Part D : <div class="text-gray-600 px-2"> {applicationData.insurance.hasMedicarePartD}</div> </div>
    
               </div>
           </div>
       </div> */}
       <div class="d-flex flex-column flex-lg-row p-5  mx-n5 row">
            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                <div class="d-flex flex-column  mt-3">
                   <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Does the patient have secondary insurance : <div class="text-gray-600 px-2">{applicationData.insurance.secondaryInsuranceCarrier} </div></div>
               </div>
           </div>
               <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
               <div class="d-flex flex-column  mt-3">
                  {applicationData.insurance.secondaryInsuranceCarrier != "No" ? <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Secondary Insurance : <div class="text-gray-600 px-2"> {applicationData.insurance.secondaryInsuranceName == "--" ? applicationData.insurance.secondaryOtherInsuranceName : applicationData.insurance.secondaryInsuranceName}</div> </div> :"" } 
    
               </div>
           </div>
       </div>
    </div>
    </div>   : 
       <div class="intro-y box mt-lg-5">
       <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
           <h2 class="fw-medium fs-base me-auto">
           {applicationData.program == 'CPR' ? "Insurance Details" : "Insurance Information"}
           </h2>
       </div>
       <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
             <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                 <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Does the patient have health insurance? <div class="text-gray-600 px-2">{applicationData.program == 'CPR' && applicationData?.viewAppInfo?.fundGroup == "Travel" ? applicationData?.insurance?.applicantInsuranceType : 'No'}</div></div>
                 </div>
            </div>
            </div>
       </div>   : 
       <div class="intro-y box mt-lg-5">
       <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
           <h2 class="fw-medium fs-base me-auto">
           {applicationData.program == 'CPR' ? "Insurance Details" : "Insurance Information"}
           </h2>
       </div>
       <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
             <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                 <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Does the patient have health insurance? <div class="text-gray-600 px-2">{(applicationData.insurance.insuranceAvailable || (applicationData.program == 'CPR' && applicationData?.viewAppInfo?.fundGroup == "Travel" && applicationData?.insurance?.applicantInsuranceType != "--")) ? 'Yes' : "No"} </div></div>
                    {applicationData.insurance.insuranceAvailable || (applicationData.program == 'CPR' && applicationData?.viewAppInfo?.fundGroup == "Travel" && applicationData?.insurance?.applicantInsuranceType != "--") && <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Insurance Type : <div class="text-gray-600 px-2">{applicationData.insurance.applicantInsuranceType}</div></div>}
                </div>
            </div>
            </div>
       </div> 
  )
}

export default Insurance